/**
 * Speed control — pause / 1x / 2x / 4x buttons (top-center) plus Space
 * to toggle pause. Drives SimLoop.timeScale.
 */
import type { SimLoop } from "../sim/loop";

export class SpeedControl {
  private el: HTMLDivElement;
  private buttons: HTMLButtonElement[] = [];
  private speeds = [0, 1, 2, 4];
  private labels = ["⏸", "1×", "2×", "4×"];
  private current = 1;

  constructor(private readonly sim: SimLoop) {
    // Coarse pointers (phones) get 44px touch targets; desktop keeps the
    // compact bar. min-height also keeps the bar thumb-reachable.
    const coarse =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(pointer: coarse)").matches;
    const pad = coarse ? "10px 14px" : "4px 10px";
    const minW = coarse ? "48px" : "38px";
    const minH = coarse ? "44px" : "0";
    this.el = document.createElement("div");
    this.el.style.cssText =
      "position:fixed;top:12px;left:50%;transform:translateX(-50%);z-index:30;" +
      "display:flex;gap:4px;background:rgba(10,10,12,0.85);border:1px solid #3a2f22;" +
      "border-radius:8px;padding:4px;max-width:96vw;";
    this.speeds.forEach((speed, i) => {
      const btn = document.createElement("button");
      btn.textContent = this.labels[i];
      btn.title = speed === 0 ? "Pause (Space)" : `${speed}× speed`;
      btn.style.cssText =
        `padding:${pad};background:#1a1c20;color:#e8e2d4;border:1px solid #3a2f22;` +
        `border-radius:5px;cursor:pointer;font-size:${coarse ? "15px" : "12px"};` +
        `min-width:${minW};min-height:${minH};`;
      btn.addEventListener("click", () => this.set(speed));
      this.el.appendChild(btn);
      this.buttons.push(btn);
    });
    document.body.appendChild(this.el);
    window.addEventListener("keydown", (e) => {
      if (e.code === "Space") {
        const tag = (e.target as HTMLElement)?.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA" || tag === "BUTTON") return;
        e.preventDefault();
        this.set(this.current === 0 ? 1 : 0);
      }
    });
    this.set(1);
  }

  set(speed: number): void {
    this.current = speed;
    this.sim.timeScale = speed;
    this.buttons.forEach((btn, i) => {
      const active = this.speeds[i] === speed;
      btn.style.borderColor = active ? "#b98b3a" : "#3a2f22";
      btn.style.color = active ? "#b98b3a" : "#e8e2d4";
    });
  }
}
